export default "__VITE_ASSET__a62d9e18__"